import { schema } from 'normalizr'
import { defaultTo, compose } from 'ramda'
import { RANGE } from 'utils/constants'

const transformValue = compose(defaultTo(null), parseFloat)

// Derive the effective value: use explicit value when present (even false/0/''),
// otherwise fall back to the default provided by the API.
const effectiveValue = (value, dflt) => (value !== undefined ? value : dflt)

// TODO: explanation
const massageFragment = (fragment, parent) => {
  // TODO: remove defualt when api figures it out
  const { configuration } = fragment
  const { definedValues = [], value, default: dflt, type } = configuration || {}

  // Bug 148571: API payloads may omit `value` but supply `default`.
  // Derive the canonical value so that Radio.Group receives a non-undefined
  // currentValue and can pre-select the correct option (e.g. "Disabled"/false).
  const canonical = effectiveValue(value, dflt)

  const withParentId = {
    ...fragment,
    configuration: {
      ...configuration,
      value: canonical,
      originalValue: canonical,
    },
    domain: parent.id,
  }

  if (type !== RANGE) return withParentId

  // if type is range we need to convert definedValues array
  // and value to a float, api cannot do this due to limitations of .net
  return {
    ...withParentId,
    configuration: {
      ...configuration,
      definedValues: definedValues.map(parseFloat),
      value: transformValue(canonical),
      originalValue: transformValue(canonical),
    },
  }
}

const fragment = new schema.Entity(
  'fragments',
  {},
  {
    idAttribute: 'refNo',
    processStrategy: massageFragment,
  }
)

const domain = new schema.Entity('domains', {
  fragments: [fragment],
})

export const powerTakeOffSchema = { domains: [domain] }
export const fragmentSchema = { fragments: [fragment] }
